import {axios} from "@/api";

const state = {
  file: ''
};

// getters
/* eslint-disable no-shadow */
const getters = {};

// actions
const actions = {
  getServices() {
    return axios.get(`${process.env.VUE_APP_API}/services/admin/v1/services`).then((result) => {
      console.log(result)
    })
  },
  async sendFile ({state}, id) {
    if (!state.file) return
    try {
      const { data } = await axios.post(`${process.env.VUE_APP_API}/services/admin/v1/contractors/${id}/generateUploadLink`)
      let config = {
        method: 'put',
        url: data.uploadUrl,
        data : state.file.file
      };
      await axios(config)
    }  catch (e) {
      console.error(e)
      this.mix__openNotification('Ошибка', 'на сервере', 'error')
    }
   }
};

// mutations
/* eslint-disable no-shadow */
const mutations = {
  setFile (state, file) {
    state.file = file
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
